var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 2.66667V11.3333H2.41667V2.66667H13.25ZM14.3333 0.5H1.33333C1.04602 0.5 0.770465 0.614137 0.567301 0.817301C0.364137 1.02047 0.25 1.29602 0.25 1.58333V12.4167C0.25 12.704 0.364137 12.9795 0.567301 13.1827C0.770465 13.3859 1.04602 13.5 1.33333 13.5H14.3333C14.6207 13.5 14.8962 13.3859 15.0994 13.1827C15.3025 12.9795 15.4167 12.704 15.4167 12.4167V8.625L19.75 12.9583V1.04167L15.4167 5.375V1.58333C15.4167 1.29602 15.3025 1.02047 15.0994 0.817301C14.8962 0.614137 14.6207 0.5 14.3333 0.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordIcon);
export default __webpack_public_path__ + "static/media/record-icon.f8e4b808a91b849f678bb1116ae6c317.svg";
export { ForwardRef as ReactComponent };